// Use REACT_APP_API_URL when provided. Otherwise default to the production
// URL in production, or to the local backend during development.
const url = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
	? "https://hris.bmahq.org"
	: "http://localhost:8888");

export default url;
